import accessControlPageActionTypes from './actionTypes';
// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import createReducer from '../../../util/createReducer';

const INITIAL_STATE = {
  isAddPolicyDialogOpen: false,
  policy: null,
  activeStep: 0,
};

const reducer = createReducer(INITIAL_STATE, {
  [accessControlPageActionTypes.ACCESS_CONTROL_PAGE_SET_EDIT_ACTIVE_STEP]: (
    state: any,
    action: any,
  ) => {
    return {
      ...state,
      activeStep: action.activeStep,
    };
  },
  [accessControlPageActionTypes.ACCESS_CONTROL_PAGE_TOGGLE_DIALOGUE]: (
    state: any,
    action: any,
  ) => {
    return {
      ...state,
      isAddPolicyDialogOpen: action.isOpen,
    };
  },
  [accessControlPageActionTypes.ACCESS_CONTROL_PAGE_SET_POLICY_TO_EDIT]: (
    state: any,
    action: any,
  ) => {
    return {
      ...state,
      policy: action.policy,
    };
  },
});

export default reducer;
